module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp3_8003.301f4ff0.png";